/**
 * Component - contactForm
 */



export const contactForm = ():void => {

  // Run the script for each individual component found on the page
  const componentSelector = document.querySelectorAll('.js-contactForm') as unknown as HTMLElement[]
  componentSelector.forEach((component:HTMLElement) => {
    
  })

}
